module.exports = __webpack_public_path__ + "static/img/14054C_3_4_C_20210111_LC.ff0d382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14054C_3_4_C_20210111_LC.png
// module id = RzF8
// module chunks = 0